<template>
    <FormSection title="Authorized Contacts" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2">
                <div class="d-flex justify-content-end" v-if="!isReOrderRequested && !showContactForm">
                    <button class="btn btn-primary mb-2" @click="requestReOrder()" v-if="totalContacts > 1">
                        Reorder Contacts
                    </button>
                    <button
                        class="btn btn-primary ms-2 mb-2"
                        @click="openAddContact()"
                        v-if="totalContacts < contactLimit"
                    >
                        Add Contact
                    </button>
                </div>
                <div class="d-flex justify-content-end" v-if="isReOrderRequested">
                    <button class="btn btn-primary mb-2" @click="confirmReOrder()" v-if="totalContacts > 1">
                        <i class="fa fa-spinner fa-spin" v-if="isSavingReOrder"></i>
                        {{ !isSavingReOrder ? "Save Reorder" : "Saving Reorder" }}
                    </button>
                    <button class="btn btn-outline-primary ms-2 mb-2" @click="cancelReOrder()">Cancel</button>
                </div>
                <div
                    :class="`material-card my-2 animated ${showContactForm ? 'faster fadeInDown' : 'slow fadeOutUp'}`"
                    v-if="showContactForm"
                >
                    <AuthorizedContactForm
                        :cahps-survey-recipient-index="cahpsSurveyRecipientIndex"
                        :patient-primary-address="patientDetails.primaryAddress"
                        :relationships-enum="relationshipsEnum"
                        :contact-roles-enum="contactRolesEnum"
                        :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                        :contact="contact"
                        :is-editable="true"
                        :total-contacts="totalContacts"
                        :is-loading="isLoading"
                        ref="addContact"
                    />
                    <footer class="d-flex justify-content-center" v-if="!isLoading">
                        <button type="button" class="btn btn-primary me-2 mb-2" @click="addContact()">
                            Add Contact
                        </button>
                        <button type="button" class="btn btn-outline-primary mb-2" @click="closeAddContact()">
                            Cancel
                        </button>
                    </footer>
                </div>
                <AuthorizedContactList
                    ref="contactList"
                    :is-re-order-requested="isReOrderRequested"
                    :patient-primary-address="patientDetails.primaryAddress"
                    v-model:total-contacts="totalContacts"
                    :patient-id="patientId"
                    v-model:cahps-survey-recipient-index="cahpsSurveyRecipientIndex"
                    :relationships-enum="relationshipsEnum"
                    :contact-roles-enum="contactRolesEnum"
                    :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                    :update-contact="updateAuthorizedContact"
                    :delete-contact="deleteAuthorizedContact"
                    :get-authorized-contacts="getAuthorizedContacts"
                    :is-loading="isGetContactsLoading"
                    :is-error="isGetContactsError"
                    :update-indices="updateIndices"
                    :contacts="contacts"
                />
            </div>
        </template>
    </FormSection>
    <div class="mt-2">
        <CahpsSurveyRecipient :contacts="contacts" />
    </div>
</template>

<script src="./AuthorizedContact.ts"></script>
